module.exports = __webpack_public_path__ + "static/Home1_Hover-2c9f6d21fef220c52a6f57b6e6d1b0e0.png";